<template>
  <v-navigation-drawer
    close-on-click
    v-if="['xs', 'sm'].includes($size)"
    right
    :value="value"
    @input="$emit('input', $event)"
    app
    width="100%"
    class="nav-drawer"
    hide-overlay
  >
    <v-list dense class="sidebar">
      <v-list-item link to="/stories">
        <v-list-item-content>
          <v-list-item-title>Your Stories</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/our-impact">
        <v-list-item-content>
          <v-list-item-title>Our Impact</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link to="/raffle-silent-auction">
        <v-list-item-content>
          <v-list-item-title>Raffle & Silent Auction</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item
        v-if="currentUser"
        link
        @click="$store.dispatch('auth/logout')"
      >
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "Sidebar",
  props: {
    value: Boolean,
  },
};
</script>

<style scoped lang="scss">
.sidebar {
  ::v-deep .v-list-item__title {
    font-size: 16px;
    line-height: 1.6em;
  }

  .v-list-item__title {
    font-family: "Roboto", sans-serif;
    font-weight: 600;
    font-size: 12px;
    line-height: 4.67em;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: white;
  }
}

.theme--light.v-navigation-drawer.nav-drawer {
  top: 60px !important;
  background-color: #1b1d21;
}
</style>
